import { ExpandableImage } from './ExpandableImage';
export default ExpandableImage;
